<div class="searchable-select-wrapper">
    <label *ngIf="label" [for]="id" [class]="labelClass">{{ label }}</label>
    <div class="searchable-select-container">
        <input 
            type="text" 
            [id]="id" 
            [class]="inputClass"
            [value]="getInputValue()"
            (focus)="onFocus()"
            (input)="onInput($event)"
            (blur)="onBlur()"
            [placeholder]="placeholder"
            [disabled]="isDisabled || disabled"
            [readonly]="isDisabled || disabled"
            autocomplete="off"
            [style.cursor]="isDropdownOpen ? 'default' : 'text'">
        <i class="fas fa-chevron-down select-arrow" [class.rotated]="isDropdownOpen"></i>
        <div class="dropdown-list" *ngIf="isDropdownOpen" (mousedown)="$event.preventDefault()">
            <div 
                *ngFor="let option of filteredOptions" 
                class="dropdown-item"
                (mousedown)="selectOption(option, $event)"
                [class.selected]="selectedValue === option">
                {{ option }}
            </div>
            <div *ngIf="filteredOptions.length === 0" class="dropdown-item no-results">
                {{ noResultsText }}
            </div>
        </div>
    </div>
</div>

